<template>
  <div class="about-us-container">
    <img
      class="about-us-logo"
      src="../assets/icon/aboutUs/logo.png"
    />
    <p class="about-us-name">Meta 彼岸</p>
    <!-- 服务协议 -->
    <div
      @click="$router.push('/agreementPolicy?type=agreement&from=h5')"
      class="order-content order-content-nomal row-between"
    >
      <div class="row-center">
        <img
          class="order-img"
          style="width:1.3125rem;height: auto;"
          src="../assets/icon/my/service.png"
        />
        <p class="collection-man-id">服务协议</p>
      </div>
      <img
        class="next-img"
        src="../assets/icon/next.png"
      />
    </div>
    <!-- 隐私政策 -->
    <div
      @click="$router.push('/agreementPolicy?type=policy&from=h5')"
      class="order-content order-content-nomal row-between"
    >
      <div class="row-center">
        <img
          class="order-img"
          style="width:1.25rem;height: auto;"
          src="../assets/icon/my/privacy.png"
        />
        <p class="collection-man-id">隐私条款</p>
      </div>
      <img
        class="next-img"
        src="../assets/icon/next.png"
      />
    </div>
    <p class="about-us-bottom-tip about-us-bottom-tip1">智链 2.0</p>
    <p class="about-us-bottom-tip about-us-bottom-tip2">提供技术支持</p>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  mounted () {
    this.$store.commit('HIDE_APPLOADING')
  },
}
</script>
<style lang="less" scoped>
.about-us-container {
  width: 100vw;
  height: 100vh;
  background: #1c1c1c;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .about-us-logo {
    width: 145px;
    height: auto;
    margin: 43px 0 68px 0;
  }
  .about-us-name {
    position: absolute;
    top: 179px;
    font-size: 20px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }
  .about-us-bottom-tip {
    font-size: 12px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
  }
  .about-us-bottom-tip1 {
    position: absolute;
    bottom: 35px;
  }
  .about-us-bottom-tip2 {
    position: absolute;
    bottom: 18px;
  }
  .order-content {
    .order-img {
      margin: 0 0.75rem;
    }
    .order-donation-compositon-img {
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      font-family: lantinghei;
      font-weight: normal;
      color: #f0f0f0;
      line-height: 19px;
    }
    .next-img {
      width: 0.5rem;
      height: 0.8125rem;
      margin-right: 1rem;
    }
  }
  .order-content-nomal {
    width: 90%;
    height: 50px;
    background: #262728;
    border-radius: 8px;
    margin-top: 0.75rem;
    cursor: pointer;
    z-index: 101;
  }
}
</style>